import { SYS_COLOR_SURFACE_NEUTRAL_300_LIGHT } from '@oneaudi/unified-web-common';
import styled from 'styled-components';

export const DriveTrainKeyfactStyle = styled.div`
	display: flex;
	flex-direction: column;
	p:last-of-type {
		&,
		sup {
			color: ${SYS_COLOR_SURFACE_NEUTRAL_300_LIGHT};
		}
	}
`;
